/**
 * Shared "no duplicate Plot No" check used by every Groundworks take-off
 * page's Plot No column (Cut & Fill, Foundations, Drainage, Plot Drives,
 * Plot Service, Plot Pavings, Scaffold, Garden, Retaining Walls,
 * Geo/Tobermore Wall) — each page commits a new Plot No value on blur (via
 * `BufferedTextInput`'s `onCommit`) and should reject it, with a
 * `message.error`, if another row already has the same value.
 *
 * Comparison is case-insensitive and trims whitespace; blank values are
 * never treated as duplicates of each other, since a freshly-added row
 * legitimately starts with an empty Plot No before the user fills it in.
 */
export function isDuplicatePlotNo(
  rows: Array<{ key: string; plotNo?: string }>,
  currentKey: string,
  candidatePlotNo: string,
): boolean {
  const normalized = candidatePlotNo.trim().toLowerCase();
  if (!normalized) return false;
  return rows.some(
    (row) => row.key !== currentKey && (row.plotNo ?? "").trim().toLowerCase() === normalized,
  );
}
